/*
 * The theme sets --header-height (used to position the mobile menu
 * drawer right below the header) once on page load and again on window
 * resize, but never on scroll. Once the user scrolls past the
 * announcement bar, the header becomes sticky at the top of the
 * viewport and its real height changes (the announcement bar is no
 * longer part of it), but --header-height keeps the stale value from
 * load time. Opening the mobile menu drawer at that point makes it
 * start too low (or, in some states, overlap the header itself),
 * either leaving a gap where page content shows through above the
 * drawer, or covering the header's own close (X) button.
 *
 * This recalculates --header-height fresh, right before the drawer
 * opens, using the same measurement the theme itself uses.
 */
(function () {
  function recalcHeaderHeight() {
    var headerEl = document.querySelector('.section-header header');
    if (!headerEl) return;
    var rect = headerEl.getBoundingClientRect();
    var divTop =
      window.scrollY === 0 || rect.top > 0
        ? rect.top + headerEl.offsetHeight
        : headerEl.offsetHeight;
    var sectionHeader = document.querySelector('.section-header');
    var sectionAB = document.querySelector('.section-announcement-bar');
    if (sectionHeader && sectionAB) {
      var rectA = sectionHeader.getBoundingClientRect();
      var rectB = sectionAB.getBoundingClientRect();
      if (rectA.bottom <= rectB.top) {
        var ab = sectionAB.querySelector('announcement-bar');
        if (ab) divTop += ab.offsetHeight;
      }
    }
    document.documentElement.style.setProperty('--header-height', divTop + 'px');
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('#menu-bar-icon-bubble') || e.target.closest('label[for="side-menu"]')) {
        recalcHeaderHeight();
      }
    },
    true
  );

  /*
   * The hamburger/close (X) icon swap relies on two CSS rules
   * (".btn-close-menu .icon-close" vs ".open-nav .icon-close") that have
   * the exact same specificity. Which one wins ends up depending on
   * cascade details that aren't reliable across all pages/states, so the
   * X sometimes fails to appear even though the menu is open. Forcing
   * the icon state directly with inline styles, driven off the same
   * "open-nav" class the theme already uses, always wins regardless of
   * that cascade tie and keeps the toggle icon in sync with the menu's
   * actual open/closed state.
   */
  function syncMenuToggleIcon() {
    var isOpen = document.documentElement.classList.contains('open-nav');
    document.querySelectorAll('.btn-close-menu').forEach(function (btn) {
      btn.querySelectorAll('.icon-menu').forEach(function (el) {
        el.style.opacity = isOpen ? '0' : '';
        el.style.visibility = isOpen ? 'hidden' : '';
      });
      var closeIcon = btn.querySelector('.icon-close');
      if (closeIcon) {
        closeIcon.style.opacity = isOpen ? '1' : '';
        closeIcon.style.visibility = isOpen ? 'visible' : '';
      }
    });
  }

  new MutationObserver(syncMenuToggleIcon).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  syncMenuToggleIcon();
})();
